import { render, staticRenderFns } from "./vidtext.vue?vue&type=template&id=6da27772&"
import script from "./vidtext.vue?vue&type=script&lang=js&"
export * from "./vidtext.vue?vue&type=script&lang=js&"
import style0 from "./vidtext.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports